'use client';

import { IosArrowLeft, IosArrowRight } from '@sgcmpteltd/uikit-react';
import cx from 'clsx';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { CAROUSEL_ICON_SIZE } from './constants';
import { PromoContent } from './promo-content';
import styles from './styles.module.scss';
import type { Component } from './types';

export const PiPromoSwiper: Component = ({
  carPromo,
  sliderClassName,
  onItemClick,
}) => (
  <div className={styles.containerSwiper}>
    <Swiper
      modules={[Navigation, Pagination]}
      navigation={{
        prevEl: '.custom-prev-btn',
        nextEl: '.custom-next-btn',
      }}
      pagination={{
        clickable: true,
        dynamicBullets: true,
      }}
      loop>
      {carPromo.map(promoItem => (
        <SwiperSlide
          key={promoItem.id}
          className={cx(
            styles.containerSwiperSlide,
            sliderClassName,
          )}>
          <div className={styles.containerTacticalAds}>
            <PromoContent
              item={promoItem}
              onItemClick={onItemClick} />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
    { carPromo.length > 1 && (
      <>
        <div
          className="custom-prev-btn"
          style={{
            position: 'absolute', left: '16px', top: '91px', zIndex: '200',
          }}>
          <div className={styles.containerArrow}>
            <IosArrowLeft
              className={styles.arrow}
              size={CAROUSEL_ICON_SIZE} />
          </div>
        </div>
        <div
          className="custom-next-btn"
          style={{
            position: 'absolute', right: '16px', top: '91px', zIndex: '200',
          }}>
          <div className={styles.containerArrow}>
            <IosArrowRight
              className={styles.arrow}
              size={CAROUSEL_ICON_SIZE} />
          </div>
        </div>
      </>
    )}

  </div>
);
